import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateModuleConfig } from '@ngx-translate/core';
import { LanguageService } from './services/language.service';
import { CachedHttpTranslationLoader } from './CachedHttpTranslationLoader';

export interface I18nModuleConfig {
  resources: ITranslationResource[];
}

export interface ITranslationResource {
  prefix: string;
  suffix?: string;
}

export function HttpLoaderFactory(http: HttpClient, resources: ITranslationResource[]) {
  return new CachedHttpTranslationLoader(http, resources);
}

@NgModule({})
export class I18nModule {
  /**
   * Use this method in your root module to provide the TranslateService and
   * initialization of LanguageService.
   */
  static forRoot(config: I18nModuleConfig): ModuleWithProviders<I18nModule> {
    const resources = config.resources.map(r => {
      return { prefix: r.prefix, suffix: r.suffix ?? '.json' };
    });
    const translateConfig: TranslateModuleConfig = {
      defaultLanguage: 'es-ES',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => HttpLoaderFactory(http, resources),
        deps: [HttpClient]
      },
      isolate: false
    };
    const translateProviders = TranslateModule.forRoot(translateConfig).providers || [];
    return {
      ngModule: I18nModule,
      providers: [...translateProviders, LanguageService]
    };
  }

  /**
   * Use this method in your other (non root) modules to import the directive/pipe
   * and initialize the LanguageService.
   */
  static forChild(config: I18nModuleConfig): ModuleWithProviders<I18nModule> {
    const resources = config.resources.map(r => {
      return { prefix: r.prefix, suffix: r.suffix ?? '.json' };
    });
    const translateConfig: TranslateModuleConfig = {
      defaultLanguage: 'es-ES',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => HttpLoaderFactory(http, resources),
        deps: [HttpClient]
      },
      isolate: false,
      extend: true
    };
    const translateProviders = TranslateModule.forChild(translateConfig).providers || [];
    return {
      ngModule: I18nModule,
      providers: [...translateProviders, LanguageService]
    };
  }

  constructor(private languageService: LanguageService) {
    this.languageService.initializeTranslateService();
  }
}
